import { buildFilterURL } from '@/components/PatientDataTable/Utils';
import { baseApi } from '@/lib/rtkQuery/baseApi';

import { FetchAdminContactLogsRequest, AdminContactLogsResponse } from '../types';

export const clinicalAdminApi = baseApi
	.enhanceEndpoints({
		addTagTypes: ['all_contact_log'],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			fetchAllContactLogs: build.query<
				AdminContactLogsResponse,
				FetchAdminContactLogsRequest
			>({
				query: ({
					ordering,
					page,
					page_size,
					search_value,
					created_from,
					created_to,
					study_id,
					contact_method,
				}) => {
					const encoded_search_value = encodeURIComponent(
						search_value ? search_value : ''
					);
					const filtersArr = [
						{ created_from },
						{ created_to },
						{ study_id },
						{ contact_method },
					];
					const urlFilters = buildFilterURL(filtersArr);
					return {
						url: `v1/engagements/contact-logs/?search=${encoded_search_value}&page=${page}&page_size=${page_size}&ordering=${ordering}${urlFilters}`,
						method: 'GET',
					};
				},
				providesTags: ['all_contact_log'],
			}),
		}),
	});

export const { useFetchAllContactLogsQuery } = clinicalAdminApi;
